export default __webpack_public_path__ + "assets/_Chapters/ServicesZerspanung/Filter/ssv-filter.png";